<template>
  <div class="">
    <v-dialog
      class="upgrade-strategy popbox"
      name="dialog2"
      v-model="isShow"
      title="添加规则"
      close-on-click-modal
      :modal="true"
      :width="668"
      @open="showopen"
      @after-close="handleAfterClose"
      @confirm="handleConfirm"
      append-to-body
    >
      <v-form ref="form" :model="ruleForm" :rules="rules">
        <v-form-item label="升级策略类型" prop="strategy_type" >
          <v-select
            id="strategy_type"
            insertContains="strategy_type"
            name="strategy_type"
            v-model="ruleForm.strategy_type"
            :disabled="isEdit"
            :options="upgradeTypeOptions"
            @change="handleStrategyTypeChange"
          ></v-select>
        </v-form-item>

        <v-form-item label="产品名称" prop="product_key" v-if="ruleForm.strategy_type === 'baseproduct'">
          <v-select
            is-search
            name="product_key"
            id="product_key"
            insertContains="product_key"
            v-model="ruleForm.product_key"
            :options="productKeyOptins"
            :disabled="isEdit"
            @change="handleProductChange"
          ></v-select>
        </v-form-item>

        <v-form-item label="源版本" prop="source_ver_id" v-if="ruleForm.strategy_type !== 'basesn'">
          <v-select
            is-search
            name="source_ver_id"
            id="source_ver_id"
            insertContains="source_ver_id"
            v-model="ruleForm.source_ver_id"
            :options="resverOptions"
            :disabled="isEdit"
          ></v-select>
        </v-form-item>

        <v-form-item label="目标版本" prop="target_ver_id">
          <v-select
            is-search
            name="target_ver_id"
            id="target_ver_id"
            insertContains="target_ver_id"
            v-model="ruleForm.target_ver_id"
            :options="resverOptions"
            :disabled="isEdit"
          ></v-select>
        </v-form-item>
        <v-form-item label="策略文件选择" prop="has_file" v-if="ruleForm.strategy_type === 'baseproduct'">
          <v-select
            name="has_file"
            id="has_file"
            insertContains="has_file"
            v-model="ruleForm.has_file"
            :options="fileOptions"
            :disabled="isEdit"
          ></v-select>
        </v-form-item>

        <v-form-item v-if="ruleForm.has_file === 1" class="listfile" label="策略文件" :required="false" prop="listFile">
          <v-upload
            action="/cgi-bin/upload"
            ref="upload"
            name="upload"
            accept=".txt,.bin"
            :WfileName="fileName"
            show-file-list
            :on-change="hidemsg"
            :noName="noName"
            :disabled="isEdit"
            @showtips="showfiletips"
          ></v-upload>
          <span class="tips">文件内容格式为:
            <span class="tipsspan"
              >KEY1
              <div class="setsn1">KEY2</div>
              <div class="setsn2">...</div>
            </span>
          </span>
          <span class="toptip">
            <v-col :offset="1" :span="2">
              <v-tooltip
                :max-width="210"
                content="添加此策略使上传文件内的KEY与指定版本绑定，使拥有这些KEY的设备们在升级时可以升级到此指定版本"
                trigger="click"
                position="top-center"
              >
                <span><img src="../../assets/img/tips.png" alt=""/></span>
              </v-tooltip>
            </v-col>
          </span>
          <div class="filetip" ref="filetip">未选择文件</div>
        </v-form-item>

        <v-form-item label="升级时间" prop="upgrade_type">
          <v-select
            id="upgrade_type"
            insertContains="upgrade_type"
            name="upgrade_type"
            v-model="ruleForm.upgrade_type"
            :options="upgradeTimeOptions"
            :disabled="isEdit"
          ></v-select>
          <p class="desc" v-if="ruleForm.upgrade_type === 1">注：升级时间的策略需设备适配</p>
        </v-form-item>

        <v-form-item label="升级时间段" prop="time" v-if="ruleForm.upgrade_type === 2">
          <v-timepicker
            is-range
            :value="[ruleForm.start_time, ruleForm.end_time]"
            placeholder="开始时间"
            endPlaceholder="结束时间"
            :disabled="isEdit"
            @change="handleTimeChange"
          >
          </v-timepicker>
        </v-form-item>

        <v-form-item label="备注" prop="memo" :required="false">
          <v-input type="textarea" class="remarks" name="memo" :maxlength="200" v-model="ruleForm.memo" show-word-limit></v-input>
          <span class="desc" :style="{ verticalAlign: 'top', paddingLeft: '8px' }">可选</span>
        </v-form-item>
      </v-form>
      <v-loading class="loading-box" :visible="!upTips" name="loading4"></v-loading>
    </v-dialog>
  </div>
</template>
<script>
import { copy } from "@/common/libs/utils";
import OSS from "ali-oss";
import SparkMD5 from "spark-md5";

const initFormData = {
  product_key: "",
  strategy_type: "basesn",
  start_time: "00:00",
  end_time: "00:00",
  file_hash: "",
  file_url: "",
  memo: "",
  source_ver_id: '',
  target_ver_id: '',
  strategy_id: "",
  strategy_status: 0,
  upgrade_type: 1,
  has_file: 1, //是否指定KEY ，不传给后台
};
export default {
  components: {},
  props: {
    showInputDialog: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      fileName: "",
      resver: [],

      rules: {
        strategy_type: copy([
          {
            type: "num",
            args: [],
          },
        ]),
        source_ver_id: "", //源版本
        target_ver_id: "", //目标版本
        memo: "", //备注
        time: (value) => {
          const startTime = parseInt(value[0].replace(':', ''))
          const endTime = parseInt(value[1].replace(':', ''))
          if(startTime >= endTime) {
            return "结束时间必须大于开始时间"
          }
        }
      },
      ruleForm: {
        ...initFormData
      },
      address: "",
      showDialog: false,
      isShow: false,

      upgradeTypeOptions: [
        { label: "基于设备KEY", value: "basesn" },
        { label: "基于产品名称", value: "baseproduct" },
      ],
      fileOptions: [
        { label: "指定KEY", value: 1 },
        { label: "不指定", value: 2 },
      ],
      upgradeTimeOptions: [
        { label: "立即升级", value: 1 },
        { label: "自定义时间段", value: 2 },
      ],
      upTips: true,
      front: "",
      after: "",
      productKeyOptins: [],
    };
  },
  computed: {
    isEdit() {
      return this.row?.strategy_id;
    },
    resverOptions() {
      if (this.ruleForm.strategy_type === "baseproduct") {
        return Object.assign([], [{ value: 0, label: "不指定" }, ...this.resver]);
      }
      return Object.assign([], this.resver);
    },
    app_id() {
      return sessionStorage.getItem("appid") || "";
    },
  },
  created() {},
  watch: {
    showInputDialog(newVal) {
      this.isShow = newVal;
    },
  },
  methods: {
    showopen() {
      this.ruleForm = { ...initFormData, ...this.row };
      this.fileName = this.ruleForm.file_url.split("/").at(-1);
      this.ruleForm.has_file = this.ruleForm.strategy_type === "baseproduct" && !this.ruleForm.file_url ? 2 : 1;
      this.getProductList();
      this.getversion();
      this.getData();
    },
    showfiletips(){
      this.$refs.filetip.style.display = "block";
    },
    hidemsg(e, file) {
      if(file.indexOf('.bin')==-1 && file.indexOf('.txt')==-1){
          this.$message.error("只支持bin、txt格式的文件")
          this.noName = true
          return false
      }
      this.noName = false
      this.$refs.filetip.style.display = "none";
      this.$message.warn("文件上传中,请等待...");
      this.upTips = false;
      let _this = this;
      if (window.FileReader) {
        var fi = e.target.files[0];
        const fileReader = new FileReader();
        fileReader.readAsBinaryString(fi);
        fileReader.onload = (e) => {
          const md5 = SparkMD5.hashBinary(e.target.result);
          _this.ruleForm.file_hash = md5.toUpperCase();
        };
      }
      if (this.ruleForm.strategy_type == "basesn") {
        this.address = `/${sessionStorage.getItem("appid") || ""}/common-strategy/base-sn/`;
      } else if (this.ruleForm.strategy_type == "baseproduct") {
        this.address = `/${sessionStorage.getItem("appid") || ""}/common-strategy/base-product/`;
      }
      this.client.put(`${this.address}` + file, e.target.files[0]).then((result) => {
        if (result.res.statusCode == 200) {
          this.$message.success("文件上传成功");
          this.upTips = true;
          this.ruleForm.file_url = result.url;
        } else {
          this.$message.error("文件上传失败");
          this.upTips = true;
        }
      });
    },
    async getData() {
      const res = await this.$getData("/td/td-iot-api/iot/oss-bridge/sts-token/v1");
      this.client = new OSS({
        region: "oss-cn-shenzhen",
        secure: true,
        accessKeyId: res.data.access_key_id,
        accessKeySecret: res.data.access_key_secret,
        bucket: "tenda-iot",
        stsToken: res.data.security_token,
      });
    },
    getProductList() {
      const submitData = {
        app_id: this.app_id,
      };
      this.$post("/td/td-iot-api/iot/common/product/list/v1", submitData, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.productKeyOptins = res.data.map((item) => {
            return {
              label: item.product_name,
              value: item.product_key,
            };
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleStrategyTypeChange(value) {
      this.ruleForm = {...initFormData, strategy_type: value}
      if(value === 'basesn') {
        this.getversion()
      } else if (value === 'baseproduct') {
        this.resver = []
      }
    },
    handleProductChange(value) {
      this.getversion(value)
    },
    async getversion(value) {
      const submitData = {
        app_id: this.app_id,
        product_key: value,
      };
      const res = await this.$getData("/td/td-iot-api/iot/firmware/version-list/v1", submitData);
      this.resver = res.data.list;
      this.resver.forEach((x) => {
        this.productKeyOptins.map((item) => {
          if (x.product_key == item.value) {
            x.productName = item.label;
          }
        });
        x.label = x.productName + "_" + x.version + "_" + x.type;
        x.value = x.id;
      });
    },
    handleTimeChange(time) {
      this.ruleForm.start_time = time[0];
      this.ruleForm.end_time = time[1];
    },
    handleConfirm() {
      const valid = this.$refs.form.submitForm();
      console.log(valid)
      if (valid === false) {
        return;
      }
      if(this.ruleForm.strategy_type == 'basesn' ||  this.ruleForm.strategy_type == 'baseproduct' && this.ruleForm.has_file === 1){
       if(this.ruleForm.file_url == ''){
        this.$refs.filetip.style.display = "block";
        this.$message.error("请检查错误信息")
        return
        }
      }

      let submitData = {
        app_id: this.app_id,
        ...this.ruleForm,
        source_ver_id: this.ruleForm.source_ver_id || 0,
        target_ver_id: this.ruleForm.target_ver_id || 0,
      };
      if (submitData.has_file === 2) {
        submitData.file_hash = "";
        submitData.file_url = "";
      }
      delete submitData.has_file;

      submitData.product_name = this.productKeyOptins.filter((item) => item.value === submitData.product_key)[0]?.label;
      submitData.source_ver = this.resverOptions.filter((item) => item.value === submitData.source_ver_id)[0]?.label;
      submitData.target_ver = this.resverOptions.filter((item) => item.value === submitData.target_ver_id)[0]?.label;
      if (submitData.source_ver_id === 0) {
        submitData.source_ver = "";
      }
      if (submitData.target_ver_id === 0) {
        submitData.target_ver = "";
      }

      if (this.isEdit) {
        this.$put(`/td/td-iot-api/iot/upgrade/force/${this.row.strategy_id}`, submitData, false).then(this.onCallback);
      } else {
        this.$post("/td/td-iot-api/iot/upgrade/force/create", submitData, false).then(this.onCallback);
      }
    },
    onCallback(res) {
      let code = +res.code;
      if (code === 0) {
        this.$emit("getData");
        this.$emit("update:showInputDialog", false);
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
    },
    handleAfterClose() {
      this.$emit("update:showInputDialog", false);
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
.upgrade-strategy {
  .listfile .tips {
    display: inline-block;
    vertical-align: middle;
    margin-left: 8px;
    // width: 90px;
    height: 32px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #999999;
    line-height: 14px;
    .tipsspan {
      position: relative;
    }
  }
  .v-col__2 {
    width: 100%;
  }
}
</style>
